import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import AccountSettings from '../../../administration/src/components/Settings/AccountSettings';

const AccountSettingsLayout = () => (
  <>
    <AccountSettings />
    <Outlet />
  </>
);

export const Route = createFileRoute('/_secured/administration/account/account-settings')({
  component: AccountSettingsLayout,
});
